import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { Card } from 'shared/mui/Card';
import { TextInput } from 'shared/react-admin/Inputs';

export const CardStyled = styled(Card)({
  border: '1px solid rgba(0, 0, 0, 0.08)',
  backgroundColor: '#FAFAFA',
  borderRadius: '8px',
  padding: '24px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export const BoxStyled = styled(Box)({
  paddingTop: '4px',
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  width: '100%',
  gap: '10px 24px',
});

export const TextInputStyled = styled(TextInput)({
  '.MuiInputBase-root': { backgroundColor: 'white' },
});
